<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import url("./assets/edit.css");
* {
  margin: 0;
  /* padding: 0; */
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-width: 1280px;
}
::-webkit-scrollbar {
  display: none;
}
.ql-align-center {
  text-indent: 0;
}
.ql-align-center img {
  width: 100%;
}
.design-html img {
  /* width: 100% ; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue